import { T as TailwindStyledElement, x } from '../../index-e3189942.js';
import { e, a as e$1 } from '../../directive-9ec64c08.js';
import { c as customClassMap } from '../../index-714323c9.js';

const style = ":host {\n    display: inline-flex\n}";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let LuksoShare = class extends TailwindStyledElement(style) {
  constructor() {
    super(...arguments);
    this.customClass = "";
    this.urls = {
      twitter: "https://twitter.com/lukso_io",
      instagram: "https://www.instagram.com/lukso",
      linkedin: "https://linkedin.com/company/lukso",
      telegram: "https://t.me/lukso",
      discord: "https://discord.gg/lukso",
      reddit: "https://www.reddit.com/r/lukso",
      medium: "https://medium.com/lukso",
      github: "https://github.com/lukso-network"
    };
  }
  linkTemplate(name, url) {
    return x`<a
      href=${url}
      target="_blank"
      class="transition-all duration-300 rounded-full hover:opacity-80 hover:shadow-button-hover-primary"
      ><img src="/assets/images/social-${name}.svg" alt=""
    /></a>`;
  }
  render() {
    const linkTemplates = [];
    for (const i of Object.keys(this.urls)) {
      linkTemplates.push(this.linkTemplate(i, this.urls[i]));
    }
    return x`<div
      class="grid gap-4 grid-cols-[repeat(4,max-content)] sm:grid-cols-[repeat(8,max-content)] ${customClassMap(
      {
        [this.customClass]: !!this.customClass
      }
    )}"
    >
      ${linkTemplates}
    </div>`;
  }
};
__decorateClass([
  e({ type: String, attribute: "custom-class" })
], LuksoShare.prototype, "customClass", 2);
LuksoShare = __decorateClass([
  e$1("lukso-share")
], LuksoShare);

export { LuksoShare };
